const CardSubInfo = ({ title, data }) => {
  return (
    <div className="flex flex-wrap justify-between text-font-color-100">
      <span>{title}</span>
      <span>{data}</span>
    </div>
  );
};

export default CardSubInfo;
